import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { getTableData } from "../../util/API/tableServices";
import DynamicTable from "../DynamicTable/DynamicTable";
import LoadingPage from "../UI/LoadingPage/LoadingPage";

const CAErrorMessage = (selectedUser) => {
  const [tableData, setTableData] = useState([]);
  const [tableSource, setTableSource] = useState(null);
  const [loading, setLoading] = useState(true);
  const [emptyMessage, setEmptyMessage] = useState(null);

  const fetchTable = async () => {
    try {
      let response = await fetch(`/tables/CAErrorTable.json`);
      const formResponseData = await response.json();
      if (formResponseData) {
        setTableSource(formResponseData);
        console.log(formResponseData)
        const tableDataResponse = await getTableData(formResponseData.services, selectedUser);
        if (tableDataResponse && tableDataResponse?.data?.header?.reccount > 0) {
          setTableData(tableDataResponse?.data?.body?.payload);
        } else {
          setEmptyMessage("No data available");
        }
        setLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch form data:", error);
    }
  };

  useEffect(() => {
    fetchTable();
  }, []);

  if (loading) return <LoadingPage />;
//   if (emptyMessage) return <Typography sx={{ p: 2 }}>{emptyMessage}</Typography>;

  return (
    <Box sx={{ p: 2 }}>
        <Typography variant="h5" sx={{ fontStyle: "Nunito" }}>Errors</Typography>
        <DynamicTable
        tableData={tableData}
        tableSource={tableSource}
        page={0}
        />
    </Box>
  );
};

export default CAErrorMessage;
